export const categories = [
  { id: 'all', name: '全部', slug: 'all', icon: 'ri-apps-line' },
  { id: 'hot', name: '热门推荐', slug: 'hot', icon: 'ri-fire-line' },
  { id: 'movie', name: '精选电影', slug: 'movie', icon: 'ri-film-line' },
  { id: 'drama', name: '热门剧集', slug: 'drama', icon: 'ri-tv-line' },
  { id: 'anime', name: '动漫动画', slug: 'anime', icon: 'ri-emotion-line' },
  { id: 'variety', name: '综艺娱乐', slug: 'variety', icon: 'ri-music-line' },
  { id: 'documentary', name: '纪录纪实', slug: 'documentary', icon: 'ri-camera-line' },
  { id: 'short', name: '短视频', slug: 'short', icon: 'ri-smartphone-line' },
];

export interface VideoItem {
  id: string;
  title: string;
  category: string;
  rating: number;
  thumbnail: string;
  description: string;
  duration: string;
  views: number;
  tags: string[];
  year: string;
}

export const videos: VideoItem[] = [
  {
    id: 'v1',
    title: '星际迷航：无尽宇宙',
    category: 'movie',
    rating: 9.2,
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20space%20movie%20poster%20with%20starship%20flying%20through%20nebula%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20dark%20background%20with%20bright%20colorful%20nebula%20clouds%2C%20movie%20poster%20style%2C%20high%20contrast%2C%20professional%20film%20photography&width=800&height=450&seq=video-thumb-01&orientation=landscape',
    description: '在遥远的未来，人类已经开启了星际殖民时代。一支勇敢的探险队踏上前往未知星系的旅程，却意外发现了一个足以改变人类命运的惊天秘密。',
    duration: '2:18:45',
    views: 1285000,
    tags: ['科幻', '冒险', '太空', '高分'],
    year: '2025',
  },
  {
    id: 'v2',
    title: '长安十二时辰之暗夜追踪',
    category: 'drama',
    rating: 9.5,
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20tang%20dynasty%20period%20drama%20scene%20with%20lanterns%20in%20ancient%20city%20at%20night%2C%20mysterious%20atmosphere%2C%20foggy%20street%2C%20traditional%20architecture%2C%20cinematic%20lighting%2C%20dramatic%20mood%2C%20film%20noir%20style&width=800&height=450&seq=video-thumb-02&orientation=landscape',
    description: '大唐天宝三年，长安城中暗流涌动。一名身负血仇的密探，在追查真相的过程中，揭开了一场惊天阴谋。',
    duration: '45:00',
    views: 2350000,
    tags: ['古装', '悬疑', '历史', '热门'],
    year: '2025',
  },
  {
    id: 'v3',
    title: '深海迷踪',
    category: 'documentary',
    rating: 9.3,
    thumbnail: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20documentary%20scene%20with%20bioluminescent%20creatures%20in%20dark%20water%2C%20mysterious%20underwater%20landscape%2C%20school%20of%20exotic%20fish%2C%20documentary%20cinematography%2C%20blue%20deep%20sea%20lighting%2C%20professional%20nature%20photography&width=800&height=450&seq=video-thumb-03&orientation=landscape',
    description: '跟随科考团队潜入千米深海，探索人类从未触及的神秘世界。从发光生物到海底热泉，带你领略地球最后的未知领域。',
    duration: '1:32:00',
    views: 876000,
    tags: ['自然', '海洋', '探索', '高分'],
    year: '2024',
  },
  {
    id: 'v4',
    title: '时光代理人',
    category: 'anime',
    rating: 9.1,
    thumbnail: 'https://readdy.ai/api/search-image?query=Stylish%20anime%20art%20scene%20with%20two%20characters%20in%20modern%20city%20at%20sunset%2C%20mysterious%20supernatural%20vibe%2C%20beautiful%20lighting%20through%20glass%20windows%2C%20anime%20film%20poster%20style%2C%20warm%20golden%20hour%20light%2C%20emotional%20atmosphere&width=800&height=450&seq=video-thumb-04&orientation=landscape',
    description: '两个拥有穿越时空能力的年轻人开了一家神秘事务所，通过照片回到过去，帮助委托人弥补遗憾。但每一次干预过去都可能引发不可预知的后果。',
    duration: '24:00',
    views: 1890000,
    tags: ['动画', '奇幻', '悬疑', '治愈'],
    year: '2025',
  },
  {
    id: 'v5',
    title: '巅峰对决：歌王之战',
    category: 'variety',
    rating: 8.9,
    thumbnail: 'https://readdy.ai/api/search-image?query=Music%20competition%20stage%20with%20dramatic%20spotlight%20and%20fog%20effects%2C%20concert%20atmosphere%2C%20grand%20stage%20design%2C%20professional%20lighting%20rig%2C%20entertainment%20show%20production%2C%20dark%20background%20with%20colorful%20stage%20lights&width=800&height=450&seq=video-thumb-05&orientation=landscape',
    description: '顶级歌手同台竞技，用音乐点燃激情。每一期都带来震撼人心的表演和令人意想不到的精彩对决。',
    duration: '1:50:00',
    views: 3200000,
    tags: ['音乐', '综艺', '竞技', '热门'],
    year: '2025',
  },
  {
    id: 'v6',
    title: '沙漠之狼',
    category: 'movie',
    rating: 8.8,
    thumbnail: 'https://readdy.ai/api/search-image?query=Western%20action%20film%20scene%20in%20vast%20desert%20landscape%20with%20lone%20rider%20silhouette%20at%20sunset%2C%20dramatic%20golden%20sky%2C%20epic%20cinematic%20composition%2C%20movie%20poster%20style%2C%20warm%20desert%20tones%2C%20adventure%20mood&width=800&height=450&seq=video-thumb-06&orientation=landscape',
    description: '一名退伍特种兵在西部荒漠中发现了一个隐藏的犯罪帝国，他独自一人踏上复仇之路，用铁血手段维护正义。',
    duration: '2:05:30',
    views: 1560000,
    tags: ['动作', '西部', '犯罪', '热血'],
    year: '2024',
  },
  {
    id: 'v7',
    title: '你好，旧时光',
    category: 'drama',
    rating: 9.4,
    thumbnail: 'https://readdy.ai/api/search-image?query=Warm%20nostalgic%20Chinese%20youth%20drama%20scene%20in%20school%20campus%20with%20cherry%20blossoms%2C%20soft%20golden%20sunlight%2C%20two%20young%20students%20walking%2C%20romantic%20coming%20of%20age%20atmosphere%2C%20gentle%20pastel%20color%20palette%2C%20emotional%20storytelling%20mood&width=800&height=450&seq=video-thumb-07&orientation=landscape',
    description: '回到那个青涩的年代，一段关于青春、友情和成长的故事。那些回不去的时光，成了最珍贵的回忆。',
    duration: '42:00',
    views: 4100000,
    tags: ['青春', '校园', '爱情', '治愈'],
    year: '2025',
  },
  {
    id: 'v8',
    title: '奇妙的动物世界',
    category: 'documentary',
    rating: 9.6,
    thumbnail: 'https://readdy.ai/api/search-image?query=Wildlife%20documentary%20scene%20in%20African%20savanna%20with%20elephants%20and%20giraffes%20at%20golden%20hour%2C%20beautiful%20natural%20light%2C%20professional%20nature%20photography%2C%20warm%20earthy%20colors%2C%20documentary%20film%20quality&width=800&height=450&seq=video-thumb-08&orientation=landscape',
    description: '从非洲大草原到亚马逊雨林，从北极冰川到澳大利亚珊瑚礁，带你走进地球上最神奇的动物王国。',
    duration: '0:58:00',
    views: 980000,
    tags: ['自然', '动物', '探索', '高分'],
    year: '2024',
  },
  {
    id: 'v9',
    title: '灵笼：最后的堡垒',
    category: 'anime',
    rating: 9.3,
    thumbnail: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20sci%20fi%20anime%20scene%20with%20floating%20city%20in%20the%20sky%2C%20dark%20industrial%20aesthetic%2C%20giant%20mechanical%20structures%2C%20dystopian%20atmosphere%2C%20dramatic%20lighting%2C%20detailed%20environment%20art%2C%20anime%20movie%20quality&width=800&height=450&seq=video-thumb-09&orientation=landscape',
    description: '末日之后，人类最后的希望悬浮于高空之中。当危机再次降临，少年们必须挺身而出，守护人类最后的家园。',
    duration: '30:00',
    views: 2780000,
    tags: ['科幻', '末日', '机甲', '热血'],
    year: '2025',
  },
  {
    id: 'v10',
    title: '舌尖上的风味之旅',
    category: 'variety',
    rating: 9.0,
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20scene%20with%20steaming%20hot%20dishes%20on%20wooden%20table%2C%20warm%20restaurant%20lighting%2C%20traditional%20Chinese%20cuisine%2C%20appetizing%20food%20photography%2C%20rich%20colors%20and%20textures%2C%20culinary%20art%20presentation&width=800&height=450&seq=video-thumb-10&orientation=landscape',
    description: '走遍大江南北，探寻隐藏在市井街巷中的地道美味。每一道菜背后都有一个动人的故事和悠久的文化传承。',
    duration: '1:05:00',
    views: 1900000,
    tags: ['美食', '文化', '旅行', '治愈'],
    year: '2025',
  },
  {
    id: 'v11',
    title: '无间道风云',
    category: 'movie',
    rating: 9.5,
    thumbnail: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20film%20scene%20in%20rainy%20city%20street%20at%20night%2C%20two%20men%20in%20trench%20coats%20facing%20each%20other%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20noir%20cinematography%2C%20tense%20atmosphere%2C%20dark%20moody%20tones&width=800&height=450&seq=video-thumb-11&orientation=landscape',
    description: '一场横跨黑白两道的生死较量。卧底警察与黑帮内鬼，两个身份错位的人，在命运的十字路口展开终极对决。',
    duration: '1:58:00',
    views: 5600000,
    tags: ['犯罪', '悬疑', '警匪', '经典'],
    year: '2024',
  },
  {
    id: 'v12',
    title: '搞笑一家人',
    category: 'short',
    rating: 8.7,
    thumbnail: 'https://readdy.ai/api/search-image?query=Funny%20comedy%20short%20video%20scene%20in%20bright%20living%20room%20with%20family%20having%20fun%2C%20warm%20home%20atmosphere%2C%20natural%20daylight%2C%20sitcom%20style%20lighting%2C%20happy%20expressions%2C%20cozy%20interior%20design&width=800&height=450&seq=video-thumb-12&orientation=landscape',
    description: '平凡家庭的不平凡日常，让人捧腹大笑又温暖治愈的系列短剧。生活中的小确幸，就在身边的每一个瞬间。',
    duration: '0:08:00',
    views: 8900000,
    tags: ['搞笑', '家庭', '短剧', '热门'],
    year: '2025',
  },
  {
    id: 'v13',
    title: '山河之恋',
    category: 'drama',
    rating: 9.1,
    thumbnail: 'https://readdy.ai/api/search-image?query=Romantic%20historical%20Chinese%20drama%20scene%20in%20ancient%20mountain%20temple%20with%20cherry%20blossoms%20falling%2C%20soft%20mist%2C%20traditional%20hanfu%20costumes%2C%20elegant%20composition%2C%20dreamy%20atmosphere%2C%20warm%20gentle%20lighting&width=800&height=450&seq=video-thumb-13&orientation=landscape',
    description: '乱世之中，一对恋人在山河之间许下诺言。跨越千山万水，只为与你重逢的那一刻。一部荡气回肠的爱情史诗。',
    duration: '48:00',
    views: 3450000,
    tags: ['古装', '爱情', '史诗', '热门'],
    year: '2025',
  },
  {
    id: 'v14',
    title: '电竞之王',
    category: 'short',
    rating: 8.6,
    thumbnail: 'https://readdy.ai/api/search-image?query=Esports%20gaming%20arena%20with%20professional%20players%20competing%20on%20stage%2C%20dramatic%20stage%20lighting%2C%20large%20LED%20screens%2C%20excited%20crowd%2C%20cyberpunk%20aesthetic%2C%20competitive%20gaming%20atmosphere&width=800&height=450&seq=video-thumb-14&orientation=landscape',
    description: '从网吧少年到世界冠军，一段关于电竞梦想的燃情故事。年轻人们用键盘和鼠标书写属于自己的传奇。',
    duration: '0:15:00',
    views: 6700000,
    tags: ['电竞', '热血', '青春', '励志'],
    year: '2025',
  },
  {
    id: 'v15',
    title: '极地奇迹',
    category: 'documentary',
    rating: 9.4,
    thumbnail: 'https://readdy.ai/api/search-image?query=Arctic%20polar%20landscape%20documentary%20scene%20with%20northern%20lights%20and%20icebergs%2C%20penguins%20on%20ice%2C%20stunning%20aurora%20borealis%2C%20pristine%20frozen%20wilderness%2C%20professional%20nature%20cinematography%2C%20cold%20blue%20and%20green%20color%20palette&width=800&height=450&seq=video-thumb-15&orientation=landscape',
    description: '在地球最极端的环境中，生命以令人惊叹的方式顽强生存。从北极熊到帝企鹅，见证极地生命的奇迹。',
    duration: '1:15:00',
    views: 720000,
    tags: ['自然', '极地', '探索', '震撼'],
    year: '2024',
  },
  {
    id: 'v16',
    title: '都市夜未眠',
    category: 'short',
    rating: 8.5,
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20city%20nightlife%20scene%20with%20colorful%20neon%20lights%20and%20busy%20streets%2C%20young%20people%20walking%2C%20urban%20lifestyle%2C%20rainy%20pavement%20reflecting%20lights%2C%20cinematic%20street%20photography%2C%20vibrant%20night%20atmosphere&width=800&height=450&seq=video-thumb-16&orientation=landscape',
    description: '深夜的城市里，每个人都有不为人知的故事。一段段在夜色中展开的都市情感，温暖每一个不眠的人。',
    duration: '0:12:00',
    views: 4500000,
    tags: ['都市', '情感', '短剧', '暖心'],
    year: '2025',
  },
];